import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { v4 as uuidv4 } from 'uuid'

import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import CloseIcon from '@material-ui/icons/Close'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import SwapHorizOutlinedIcon from '@material-ui/icons/SwapHorizOutlined'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

import { makeStyles } from '@material-ui/core/styles'
// import Button from '@material-ui/core/Button'
import { Alert, AlertTitle } from '@material-ui/lab'
import IconButton from '@material-ui/core/IconButton'

import RpcApiClient from 'datasources/RpcApiClient'

import '../filesMenu.css'

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
    width: 120,
    margin: 'auto',
    '& .MuiOutlinedInput-root': {
      height: 37,
    },
    '& .MuiSelect-outlined': {
      height: 37,
    },
    '& .MuiSelect-select': {
      height: 17,
      padding: '0px 0px 0px 10px;',
    },
  },
  selectEmpty: {
    // marginTop: theme.spacing(2),
  },
}))

function UploadModal(props) {
  const classes = useStyles()
  const authData = useSelector((state) => state.auth.authData)
  const userCompany = useSelector((state) => state.companyState.id)

  const [userInfoLoading, setUserInfoLoading] = useState(false)
  // const [userInfo, setUserInfo] = useState({})
  const [fileList, setFileList] = useState([])
  const [fileExist, setFileExist] = useState(false)
  const [share, setShare] = useState('Public')
  const [loadingUpload, setLoadingUpload] = useState(true)
  const [idFile, setIdFile] = useState('')
  const [alertContent, setAlertContent] = useState({ severity: '', title: '', message: '', active: false })
  const [downloadFile, setDownloadFile] = useState({
    name: '',
    lastModified: 0,
    size: 0,
    type: '',
    webkitRelativePath: '',
  })

  const getFiles = async () => {
    setFileList([])
    const allFiles = []
    try {
      const body = {
        company: userCompany,
        plan: '',
        country: 'Mexico',
        files: [],
      }
      const body2 = {
        company: userCompany,
        client_email: authData.email,
        plan: '',
        country: 'Mexico',
        files: [],
      }
      const response = await RpcApiClient.getFiles(authData.jwtToken, body)
      response.data.body.map((file) => allFiles.push(file))
    } catch (err) {
      console.log(err)
    }
    try {
      const body = {
        company: userCompany,
        client_email: authData.email,
        plan: '',
        country: 'Mexico',
        files: [],
      }
      const response = await RpcApiClient.getFiles(authData.jwtToken, body)
      response.data.body.map((file) => allFiles.push(file))
    } catch (err) {
      console.log(err)
    }
    setFileList(allFiles)
    setUserInfoLoading(true)
  }

  useEffect(() => {
    // console.log(props.currentProject)
    getFiles()
    const filtered = {
      type: 'FeatureCollection',
      features: props.features.features.filter((val) => val.properties.id === props.folderId),
    }
    filtered.features.map((data) => {
      data.properties.colorCode ? (data.properties.colorCode = JSON.stringify(data.properties.colorCode)) : null
      data.properties.colorCodeB ? (data.properties.colorCodeB = JSON.stringify(data.properties.colorCodeB)) : null
    })
    var blob = new Blob([JSON.stringify(filtered)], { type: 'application/json' })
    const file = new File([blob], `${props.folderId}.geojson`, { type: 'application/json' })
    setDownloadFile(file)
  }, [])

  const validateFiles = () => {
    const condition = (element) => element.name === downloadFile.name.replace('.geojson', '')

    const publicFiles = fileList.filter((file) => file.type === 'public')
    const privateFiles = fileList.filter((file) => file.type === 'private')

    if (share === 'Public') {
      setFileExist(publicFiles.some(condition))
      return publicFiles.some(condition)
    }
    if (share === 'Private') {
      setFileExist(publicFiles.some(condition))
      return privateFiles.some(condition)
    }
  }

  const getId = (file_name) => {
    const publicFiles = fileList.filter((file) => file.type === 'public')
    const privateFiles = fileList.filter((file) => file.type === 'private')

    if (share === 'Public') {
      const file = publicFiles.find((file) => file.name === file_name.replace('.geojson', ''))
      return file.id
    }
    if (share === 'Private') {
      const file = privateFiles.find((file) => file.name === file_name.replace('.geojson', ''))
      return file.id
    }
  }

  const getUrl = (id) => {
    const fileData = fileList.find((val) => val.id === id)
    const uploadUrl = fileData.key + '/' + fileData.id + '.geojson'
    return uploadUrl
  }

  const upload = () => {
    if (!validateFiles()) {
      const fileId = uuidv4()
      const uploadUrl =
        share === 'Public'
          ? // ? userCompany + '/' + downloadFile.name
            // : userCompany + '/' + authData.email + '/' + downloadFile.name
            userCompany + '/' + fileId + '.geojson'
          : userCompany + '/' + authData.email + '/' + fileId + '.geojson'
      setLoadingUpload(false)
      try {
        const request = RpcApiClient.uploadFiles(authData.jwtToken, {
          upload_to: uploadUrl,
          content_type: downloadFile.type,
        })

        const body = {
          data: {
            document_id: fileId,
            file_name: downloadFile.name.replace('.geojson', ''),
            file_type: share === 'Public' ? 'public' : 'private',
            blocked: false,
            shared_list: [],
            user: authData.email,
            company: userCompany,
            // private: share === 'Public' ? false : true,
            file_key: share === 'Public' ? userCompany : userCompany + '/' + authData.email,
          },
          options: {
            action: 'create',
          },
        }

        request.then((uploadResponse) => {
          const fields = uploadResponse.data.upload_url.fields

          const formData = new FormData()
          Object.keys(fields).forEach((key) => {
            formData.append(key, fields[key])
          })
          formData.append('file', downloadFile)

          fetch(uploadResponse.data.upload_url.url, {
            method: 'POST',
            body: formData,
            mode: 'no-cors',
          }).then(() => {
            RpcApiClient.createDocumentGeocreator(authData.jwtToken, body).then(() => {
              setLoadingUpload(true)
              setTimeout(() => {
                props.setUploadModal(false)
              }, 3000)
            })
            setLoadingUpload(true)
            setAlertContent({
              severity: 'success',
              title: 'Success',
              message: 'The project has been successfully uploaded',
              active: true,
            })
            // props.setUploadModal(false)
          })
        })
      } catch (err) {
        setAlertContent({
          severity: 'error',
          title: 'Error',
          message: 'Something went wrong, please try again',
          active: true,
        })
        console.log(err)
      }
    } else {
      setFileExist(true)
    }
  }

  const overwrite = () => {
    const fileKey = getId(downloadFile.name)
    // console.log(fileKey)
    const uploadUrl =
      share === 'Public'
        ? userCompany + '/' + fileKey + '.geojson'
        : userCompany + '/' + authData.email + '/' + fileKey + '.geojson'
    setLoadingUpload(false)
    try {
      const request = RpcApiClient.uploadFiles(authData.jwtToken, {
        upload_to: uploadUrl,
        content_type: downloadFile.type,
      })

      request.then((uploadResponse) => {
        const fields = uploadResponse.data.upload_url.fields

        const formData = new FormData()
        Object.keys(fields).forEach((key) => {
          formData.append(key, fields[key])
        })
        formData.append('file', downloadFile)

        fetch(uploadResponse.data.upload_url.url, {
          method: 'POST',
          body: formData,
          mode: 'no-cors',
        }).then(() => {
          setLoadingUpload(true)
          setAlertContent({
            severity: 'success',
            title: 'Success',
            message: 'The project has been successfully uploaded',
            active: true,
          })
          // props.setUploadModal(false)
        })
      })
    } catch (err) {
      setAlertContent({
        severity: 'error',
        title: 'Error',
        message: 'Something went wrong, please try again',
        active: true,
      })
      console.log(err)
    }
  }

  const deleteProject = () => {
    props.deleteFeatures()
    const body = {
      isBlocked: false,
      files: [props.currentProject],
    }
    RpcApiClient.lockFiles(authData.jwtToken, body)

    const updateLabels = props.projects.filter((val, i) => val.project_id !== props.currentProject.project_id)
    if (updateLabels.length > 0) {
      updateLabels.map((val, i) => (i === 0 ? (val.active = true) : (val.active = false)))
      props.setProjects(updateLabels)
      props.setProject(updateLabels[0].projectName)
    } else {
      props.setProjects([{ projectName: 'New Project', visible: true, active: true, height: true }])
      props.setProject('New Project')
    }
  }

  const update = (unlock) => {
    // console.log(fileKey)
    const uploadUrl = getUrl(props.currentProject.project_id)
    setLoadingUpload(false)
    try {
      const request = RpcApiClient.uploadFiles(authData.jwtToken, {
        upload_to: uploadUrl,
        content_type: downloadFile.type,
      })

      request.then((uploadResponse) => {
        const fields = uploadResponse.data.upload_url.fields

        const formData = new FormData()
        Object.keys(fields).forEach((key) => {
          formData.append(key, fields[key])
        })
        formData.append('file', downloadFile)

        fetch(uploadResponse.data.upload_url.url, {
          method: 'POST',
          body: formData,
          mode: 'no-cors',
        }).then(() => {
          setLoadingUpload(true)
          setAlertContent({
            severity: 'success',
            title: 'Success',
            message: 'The project has been successfully updated',
            active: true,
          })
          unlock ? deleteProject() : null
          setTimeout(() => {
            props.setUploadModal(false)
          }, 3000)
          // props.setUploadModal(false)
        })
      })
    } catch (err) {
      setAlertContent({
        severity: 'error',
        title: 'Error',
        message: 'Something went wrong, please try again',
        active: true,
      })
      console.log(err)
    }
  }

  const resetStates = () => {
    setUserInfoLoading(false)
    setFileList([])
    setShare('Public')
    setLoadingUpload(true)
    setDownloadFile({
      name: '',
      lastModified: 0,
      size: 0,
      type: '',
      webkitRelativePath: '',
    })
    props.setUploadModal(false)
  }

  const format = (val) => {
    if (val < 1048546) return new Intl.NumberFormat('en').format(val) + ' Bytes'
    if (val >= 1048546) return new Intl.NumberFormat('en').format(Math.floor(val / 1048576)) + ' MB'
  }

  const uploadAlert = (
    <Alert severity={alertContent.severity}>
      <AlertTitle>{alertContent.title}</AlertTitle>
      {alertContent.message}
    </Alert>
  )

  if (userInfoLoading && loadingUpload) {
    return (
      <div className="save-file-modal">
        <IconButton
          size="small"
          component="span"
          className="sf-modal-close"
          onClick={() => {
            props.setUploadModal(false)
            setAlertContent({ severity: '', title: '', message: '', active: false })
          }}
        >
          <CloseIcon />
        </IconButton>
        {!props.currentProject.s3 ? <h3>Upload Project</h3> : <h3>Update Project</h3>}
        {!alertContent.active ? (
          <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>
            <div
              style={{ display: 'flex', height: '50px', background: '#f0f0f0', borderRadius: '5px', padding: '10px' }}
            >
              <label style={{ height: 'fit-content', alignSelf: 'center', color: '#7d7d7d' }}>
                {' '}
                <b> {downloadFile.name.replace('.geojson', '')} </b>{' '}
              </label>
              <label
                style={{
                  height: 'fit-content',
                  alignSelf: 'center',
                  color: '#7d7d7d',
                  margin: 'auto',
                  marginRight: '0px',
                  fontSize: '12px',
                }}
              >
                {format(downloadFile.size)}
              </label>
            </div>
            {!props.currentProject.s3 ? (
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel htmlFor="outlined-age-native-simple">Share</InputLabel>
                <Select value={share} onChange={(e) => setShare(e.target.value)} autoWidth={true} label="Share">
                  <MenuItem value="Public" style={{ fontSize: '14px' }}>
                    Public
                  </MenuItem>
                  <MenuItem value="Private" style={{ fontSize: '14px' }}>
                    Private
                  </MenuItem>
                </Select>
              </FormControl>
            ) : null}

            {fileExist ? (
              <div style={{ display: 'grid', gap: '10px' }}>
                <h4>
                  The <b>{downloadFile.name.replace('.geojson', '')}</b> project already exist
                </h4>

                <div className="upload-option replace">
                  <SwapHorizOutlinedIcon className="upload-option-icons" style={{ color: '#ffa700' }} />
                  <label style={{ height: '20px', alignSelf: 'center' }}>Replace the project</label>
                  <button className="upload-btn-options replace-btn" onClick={() => overwrite()}>
                    OVERWRITE
                  </button>
                </div>

                <div className="upload-option rename">
                  <DescriptionOutlinedIcon className="upload-option-icons" style={{ color: '#00dd0e' }} />
                  <label style={{ height: '20px', alignSelf: 'center' }}>Rename the project</label>
                  <button
                    className="upload-btn-options rename-btn"
                    onClick={() => {
                      props.setRenameModal(true)
                      resetStates()
                    }}
                  >
                    RENAME
                  </button>
                </div>

                <div className="upload-option cancel" style={{ width: '90px', margin: 'auto' }}>
                  <button
                    className="upload-btn-options cancel-btn"
                    style={{ margin: 'auto' }}
                    onClick={() => resetStates()}
                  >
                    CANCEL
                  </button>
                </div>
              </div>
            ) : !props.currentProject.s3 ? (
              <button
                class="files-manager-btn ripple"
                style={{ width: '140px', margin: 'auto', display: 'block' }}
                onClick={() => upload()}
                // onClick={() => console.log(validateFiles())}
              >
                UPLOAD
              </button>
            ) : (
              <div style={{ display: 'grid', gap: '10px' }}>
                <button
                  class="files-manager-btn ripple"
                  style={{ width: '140px', margin: 'auto', display: 'block' }}
                  onClick={() => update(false)}
                  // onClick={() => console.log(validateFiles())}
                >
                  UPDATE
                </button>
                <button
                  class="files-manager-btn ripple"
                  style={{ width: '140px', margin: 'auto', display: 'block' }}
                  onClick={() => update(true)}
                  // onClick={() => console.log(validateFiles())}
                >
                  UPDATE & UNLOCK
                </button>
              </div>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', flexFlow: 'column', gap: '15px' }}>{uploadAlert}</div>
        )}
      </div>
    )
  } else {
    return (
      <div className="save-file-modal">
        <div style={{ height: '156px', width: '100%', display: 'flex' }}>
          <Spin
            style={{ margin: 'auto', alignSelf: 'center', color: '#03a9f4' }}
            tip="Loading..."
            size="large"
            indicator={<LoadingOutlined />}
          ></Spin>
        </div>
      </div>
    )
  }
}

export default UploadModal
